

import { OptionsObject, SnackbarMessage, useSnackbar } from "notistack";
import { useCallback, useEffect } from "react";
import events from "../../../src/json/events/events";
import eventEmitter from "../../services/event.emitter";




export default function EventListeners() {
  const { enqueueSnackbar } = useSnackbar();

  const showNotifications = useCallback(
    (data) => {
      const { message, options } = data;
      enqueueSnackbar(message, options);
    },
    [enqueueSnackbar]
  );

  useEffect(() => {
    eventEmitter.on(events.showNotification, showNotifications);
    return () => {
      eventEmitter.off(events.showNotification, showNotifications);
    };
  }, [showNotifications]);


  

 

  return null;
}
